import { EMPTY_OBJ } from '@constants';

import useResourceList from './useResourceList';
import mutationFactory from './mutationFactory';
import useQuery from './useQuery';

import api from '..';

export const useSchedulesList = (queryVariables = {}, queryConfig = {}) => {
  const { data: schedules = [], ...queryResult } = useResourceList(
    { name: 'schedules', api: api.schedules },
    queryVariables,
    queryConfig,
  );

  return {
    schedules,
    ...queryResult,
  };
};

export const useSchedule = ({ id }, queryConfig = {}) => {
  const queryResult = useQuery(['schedules', { id }], api.schedules.getById, {
    ...queryConfig,
    enabled: id,
  });

  return {
    schedule: queryResult.data || EMPTY_OBJ,
    ...queryResult,
  };
};

export const useDaysForSchedule = ({ eventId }, queryConfig = {}) => {
  const queryResult = useQuery(['schedules', { eventId }], api.schedules.getDays, {
    ...queryConfig,
  });

  return {
    scheduleDays: queryResult.data || EMPTY_OBJ,
    ...queryResult,
  };
};

const createMutation = mutationFactory({ invalidate: 'schedules' });

export const useDeleteSchedule = createMutation(api.schedules.remove);

export const useCreateSchedule = createMutation(api.schedules.create);

export const useSaveSchedule = createMutation(api.schedules.save);

export const useUpdateSchedule = createMutation(api.schedules.update);
